import axios from "axios";
import { requestInterceptor } from "common-frontend-components";

const pulseApi = axios.create({ baseURL: "/pulse-api" });
pulseApi.interceptors.request.use(requestInterceptor);

const getPulseInstanceIdByProductInstanceId = async (
    productInstanceId: number,
): Promise<{ id: number }> =>
    (await pulseApi.get(`/pulse-instances/by-product-instance/${productInstanceId}`)).data;

export { getPulseInstanceIdByProductInstanceId };
